import { CircularProgress } from '@mui/material';
import { UptimeTypography } from '@uptime/uptime-component';
import styled from 'styled-components';
import DefaultUptimeTheme from 'utils/lumosTheme';

export const DelegationMessage = styled(UptimeTypography)(
  ({ theme }: { theme: typeof DefaultUptimeTheme }) => `
    color: ${theme.uptimeColors.generalColors.state.danger.light};
`);

export const StyledCircularProgress = styled(CircularProgress)(
  ({ theme }: { theme: typeof DefaultUptimeTheme }) => `
    color: ${theme.uptimeColors.mainTheme.secondary} !important;
`);
